import styled, { keyframes } from "styled-components";

// Loading-skeleton primitives shared by the list/detail pages. Visuals match
// the design system's TableLoadingSkeleton bar (opacity pulse 0.3↔0.6 on
// theme.tableBorder, 12px tall, 4px radius) so hand-placed skeletons and the
// table-level ones read as one family.
export const skeletonPulse = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.6; }
`;

// A single pulsing bar. Size via $width/$height (defaults mirror the DS bar).
export const SkeletonBar = styled.div<{ $width?: string; $height?: string }>`
  width: ${(props) => props.$width ?? "60%"};
  height: ${(props) => props.$height ?? "12px"};
  border-radius: 4px;
  background-color: ${(props) => props.theme.tableBorder};
  animation: ${skeletonPulse} 1.5s ease-in-out infinite;
`;

// Badge-shaped placeholder for status pills (live/idle, job status).
export const SkeletonPill = styled(SkeletonBar)`
  width: ${(props) => props.$width ?? "48px"};
  height: ${(props) => props.$height ?? "20px"};
  border-radius: 10px;
`;

// Card/block-shaped placeholder for whole sections (flow graph, tab bodies).
export const SkeletonBlock = styled(SkeletonBar)`
  width: ${(props) => props.$width ?? "100%"};
  border-radius: 8px;
`;

// A stack of text-line bars with a shorter last line, for log/list bodies.
const TextLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export function SkeletonText({ lines = 3 }: { lines?: number }) {
  const keys = Array.from({ length: lines }, (_, i) => `line-${i}`);
  return (
    <TextLines aria-hidden="true">
      {keys.map((key, i) => (
        <SkeletonBar key={key} $width={i === lines - 1 ? "40%" : "100%"} />
      ))}
    </TextLines>
  );
}
